import React, { Component } from 'react';
import { Table, Row, InputNumber, Input, Col, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { data3_1_1 } from '../3-1-1/data';
import { data3_1_4_default } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import Compared from "../../../Compared";
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

const numConvert = (num = 0) => {
    num = Number(num || "0")
    return num
};

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            data3_1_4: [],
            data3_1_1: [],
            loading: false,
            print: false
        }
    }


    componentDidMount() {
        this.setState({ loading: true });
        this.getTable3_1_1(this.state.date);
    }


    // 表格里面一些需要计算的数据
    computeNum = (data, data3_1_4) => {
        // console.log(data);
        // console.log(this.state.data3_1_4)
        // var data3_1_4 = this.state.data3_1_4;
        const len = data.length;
        // 计算总值 
        let total = {
            name: 'Total',
            name_code: "Rooms_Available",
            rooms: 0,
            rooms_avaliable: 0,
            rooms_sold: 0,
            occ: 0,
            revn: 0,
            avg_rate: 0,
            revpar: 0,
            mpi: "-",
            mpi_ranking: '-',
            ari: "-",
            ari_ranking: '-',
            rgi: "-",
            rgi_ranking: '-',
            // year: 2018,
            // month: 5
        };
        for (let i in data) {
            if (i < 5) {
                //可售房rooms_avaliable 售出房数rooms_sold 客房收入renv 使用data3_1_2的数据
                data[i]['rooms_avaliable'] = data3_1_4[i]['rooms_avaliable'];
                data[i]['rooms_sold'] = data3_1_4[i]['rooms_sold'];
                data[i]['revn'] = data3_1_4[i]['revn'];

                total['rooms'] += Number(data[i]['rooms']);
                total['rooms_avaliable'] += Number(data[i]['rooms_avaliable']);
                total['rooms_sold'] += Number(data[i]['rooms_sold']);
                total['revn'] += Number(data[i]['revn']);
            }
        }
        // console.log(total);
        total['occ'] = Number(total['rooms_avaliable']) == 0 ? 0 : (Number(total['rooms_sold']) / Number(total['rooms_avaliable']) * 100).toFixed(2) + '%';
        total['avg_rate'] = Number(total['rooms_sold']) == 0 ? 0 : (Number(total['revn']) / Number(total['rooms_sold'])).toFixed(2);
        total['revpar'] = Number(total['rooms_avaliable']) == 0 ? 0 : (Number(total['revn']) / Number(total['rooms_avaliable'])).toFixed(2);

        let mpi = [];
        let ari = [];
        let rgi = [];
        for (let i in data) {
            if (i < 5) {
                //客房率
                data[i]['occ'] = (Number(data[i]['rooms_avaliable']) == 0 ? 0 : (Number(data[i]['rooms_sold']) / Number(data[i]['rooms_avaliable'])) * 100).toFixed(2) + '%';
                //平均房价
                data[i]['avg_rate'] = (Number(data[i]['rooms_sold']) == 0 ? 0 : (Number(data[i]['revn']) / Number(data[i]['rooms_sold']))).toFixed(2);
                //可售房平均收入
                data[i]['revpar'] = (Number(data[i]['rooms_avaliable']) == 0 ? 0 : (Number(data[i]['revn']) / Number(data[i]['rooms_avaliable']))).toFixed(2);
                //市场渗透率
                data[i]['mpi'] = (Number(total['occ'])) == 0 ? 0 : (parseFloat(data[i]['occ']) / parseFloat(total['occ'])).toFixed(2);
                mpi.push({
                    data: data[i]['mpi'],
                    key: i
                })
                //排名
                //平均房价指数
                data[i]['ari'] = (Number(total['avg_rate'])) == 0 ? 0 : (Number(data[i]['avg_rate']) / Number(total['avg_rate'])).toFixed(2);
                ari.push({
                    data: data[i]['ari'],
                    key: i
                })
                //排名
                //RGI收益率
                data[i]['rgi'] = (Number(total['revpar'])) == 0 ? 0 : (Number(data[i]['revpar']) / Number(total['revpar'])).toFixed(2);
                rgi.push({
                    data: data[i]['rgi'],
                    key: i
                })
            }
        }

        data[5] = total;
        // 计算排名
        mpi.sort((a, b) => {
            return b.data - a.data
        });
        ari.sort((a, b) => {
            return b.data - a.data
        });
        rgi.sort((a, b) => {
            return b.data - a.data
        });
        mpi.forEach((x, i) => {
            data[x.key].mpi_ranking = i + 1;
        });
        ari.forEach((x, i) => {
            data[x.key].ari_ranking = i + 1;
        });
        rgi.forEach((x, i) => {
            data[x.key].rgi_ranking = i + 1;
        });
        if (data3_1_4[0] && data3_1_4[0].id) {
            data.forEach((item, i) => {
                if (i <= 4) {
                    data[i].id = data3_1_4[i].id;
                }
            })
        }
        this.setState({
            data: data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // console.log(data);return;
        // this.setState({
        //     data
        // });
        // console.log(data);return;
        this.computeNum(this.state.data3_1_1, data);
    }
    // 从后台取出表格3_1_1的数据
    getTable3_1_1 = (date) => {
        const dataBegin = JSON.stringify(data3_1_1);
        let data = JSON.parse(dataBegin);
        fetch(`/_3_1_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = data.map((item, i) => {
                    if (i <= 4 && x.data[i].name) {
                        return { ...item, name: x.data[i].name, rooms: x.data[i].rooms }
                    } else {
                        return item
                    }
                })
            }
            this.setState({
                data3_1_1: data
            });
            this.getTable3_1_4(date);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    // 从后台取出表格3_1_4的数据
    getTable3_1_4 = (date) => {
        const dataBegin = JSON.stringify(data3_1_4_default);
        let data3_1_4 = JSON.parse(dataBegin);
        fetch(`/_3_1_4_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data3_1_4 = x.data;
            }
            this.setState({
                data3_1_4,
                loading: false
            });
            this.computeNum(this.state.data3_1_1, data3_1_4);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        console.log(data)
        // 删除total这列数据
        data.pop();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_3_1_4', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable3_1_4(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_1_4', 1.5, '4.63', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `YTD This Year 本年累计 ${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table4_6_3').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    render() {
        const data = this.state.data;
        const print = this.state.print;
        const totalData = [5];
        const columns = [{
            align: "center",
            title: <div>Hotel <br /> 酒店</div>,
            dataIndex: 'name',
            key: 'name',
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            align: "center",
            title: <div>Rooms <br /> 客房数</div>,
            dataIndex: 'rooms',
            key: 'rooms',
            width: 100,
            render: (text, record, index) => {
                const title = ['Rooms 客房数'];
                return (
                    <Compared data={{ index, key: 'rooms', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {Number(text || '0') < 0 ?
                                <span style={{ color: "red" }}>
                                    ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                :
                                Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Rms Avaliable <br /> 可售客房数</div>,
            dataIndex: 'rooms_avaliable',
            key: 'rooms_avaliable',
            width: 150,
            render: (text, record, index) => {
                const title = ['Rms Avaliable 可售客房数'];
                if (index == 5 || print) {
                    return (
                        <Compared data={{ index, key: 'rooms_avaliable', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )
                }
                return (
                    <Compared data={{ index, key: 'rooms_avaliable', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className="table-color table-color-number">
                            <InputNumber
                                className="input-width"
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('rooms_avaliable', value, index)
                                }}
                            // onChange={(value) => {
                            //     this.onChange('actual', value, index)
                            // }}
                            />
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Rms Sold <br /> 售出房数</div>,
            dataIndex: 'rooms_sold',
            key: 'rooms_sold',
            width: 100,
            render: (text, record, index) => {
                const title = ['Rms Sold 售出房数'];
                if (index == 5 || print) {
                    return (
                        <Compared data={{ index, key: 'rooms_sold', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )
                }
                return (
                    <Compared data={{ index, key: 'rooms_sold', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className="table-color table-color-number">
                            <InputNumber
                                className="input-width"
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('rooms_sold', value, index)
                                }}
                            // onChange={(value) => {
                            //     this.onChange('actual', value, index)
                            // }}
                            />
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>OCC <br /> 客房率</div>,
            dataIndex: 'occ',
            key: 'occ',
            width: 100,
            render: (text, record, index) => {
                const title = ['OCC 客房率'];
                return (
                    <Compared data={{ index, key: 'occ', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Revn <br /> 客房收入</div>,
            dataIndex: 'revn',
            key: 'revn',
            width: 100,
            render: (text, record, index) => {
                const title = ['Revn 客房收入']
                if (index == 5 || print) {
                    return (
                        <Compared data={{ index, key: 'revn', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )
                }
                return (
                    <Compared data={{ index, key: 'revn', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className="table-color table-color-number">
                            <InputNumber
                                className="input-width"
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('revn', value, index)
                                }}
                            // onChange={(value) => {
                            //     this.onChange('actual', value, index)
                            // }}
                            />
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Avg Rate <br /> 平均房价</div>,
            dataIndex: 'avg_rate',
            key: 'avg_rate',
            width: 100,
            render: (text, record, index) => {
                const title = ['Avg Rate 平均房价']
                return (
                    <Compared data={{ index, key: 'avg_rate', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {Number(text || '0') < 0 ?
                                <span style={{ color: "red" }}>
                                    ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                :
                                Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>RevPAR <br /> 可售房平均收入</div>,
            dataIndex: 'revpar',
            key: 'revpar',
            width: 100,
            render: (text, record, index) => {
                const title = ['RevPAR 可售房平均收入']
                return (
                    <Compared data={{ index, key: 'revpar', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {Number(text || '0') < 0 ?
                                <span style={{ color: "red" }}>
                                    ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                :
                                Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>MPI <br /> 市场渗透率指数</div>,
            dataIndex: 'mpi',
            key: 'mpi',
            width: 100,
            render: (text, record, index) => {
                const title = ['MPI 市场渗透率指数']
                return (
                    <Compared data={{ index, key: 'mpi', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text || ""}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Ranking <br /> 排名</div>,
            dataIndex: 'mpi_ranking',
            key: 'mpi_ranking',
            width: 100,
            render: (text, record, index) => {
                const title = ['Ranking 排名']
                return (
                    <Compared data={{ index, key: 'mpi_ranking', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>ARI <br /> 平均房价指数</div>,
            dataIndex: 'ari',
            key: 'ari',
            width: 100,
            render: (text, record, index) => {
                const title = ['ARI 平均房价指数']
                return (
                    <Compared data={{ index, key: 'ari', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Ranking <br /> 排名</div>,
            dataIndex: 'ari_ranking',
            key: 'ari_ranking',
            width: 100,
            render: (text, record, index) => {
                const title = ['Ranking 排名']
                return (
                    <Compared data={{ index, key: 'ari_ranking', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>RGI <br /> 收益率指数</div>,
            dataIndex: 'rgi',
            key: 'rgi',
            width: 100,
            render: (text, record, index) => {
                const title = ['RGI 收益率指数']
                return (
                    <Compared data={{ index, key: 'rgi', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }, {
            align: "center",
            title: <div>Ranking <br /> 排名</div>,
            dataIndex: 'rgi_ranking',
            key: 'rgi_ranking',
            width: 100,
            render: (text, record, index) => {
                const title = ['Ranking 排名']
                return (
                    <Compared data={{ index, key: 'rgi_ranking', title, sqlName: "_3_1_4", name: record.name, type: 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    </Compared>
                )
            }
        }];
        return (
            <Spin spinning={this.state.loading}>
                <div className="table">
                    <Row className="title" id="table3_1_4">
                        {/* <Row>3.1 Rooms KPI Analysis 客房关键绩效指数分析</Row> */}
                        <Row className="vice-title">4.6.3 YTD This Year 本年累计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, 'YYYY-MM')}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getTable3_1_1(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            className="content"
                            bordered
                            id="table4_6_3"
                            pagination={false}
                            rowKey={(record, index) => {
                                return index
                            }}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.onExpoetExcel}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_3_1">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-1/3-1-4/index.js